import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useSelector } from "react-redux";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import {
  setSelectedEntityType,
  setTrafficSourceFilter,
} from "../../../../../features/metaEntitiesSlice";
import { useSearchParams } from "react-router-dom";

interface TrafficClickIdentifierProps {
  open: boolean;
  handleClose: () => void;
  identifierName: any;
  SetIdentifierName: any;
  trafficSource: any;
  SetTrafficSource: any;
  trafficClickIdentifier: any;
  selectedRowData: any;
  setSelectedRowData: any;
  selectedShareuid: any;
  setSelectedSharedUid: any;
  setTrafficClickIdentifier: any;
}

function EditTrafficClickIdentifierModal({
  open,
  handleClose,
  identifierName,
  SetIdentifierName,
  trafficSource,
  SetTrafficSource,
  selectedRowData,
  selectedShareuid,
}: TrafficClickIdentifierProps) {
  const token = useSelector(setUserToken);
  const outhTokenHeader = token?.payload?.user?.userToken;
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const updateTrafficClickIdentifiers = async () => {
    const data = {
      identifier: identifierName,
      traffic_source: trafficSource,
    };
    try {
      setLoading(true);
      setIsLoading(true);
      if (outhTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.updateMetaTrafficClickIdentifiers(
          outhTokenHeader,
          data,
          selectedShareuid
        );
        dispatch(setSelectedEntityType(""));
        dispatch(setTrafficSourceFilter(null));
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete("filters"); // Remove filters
        setSearchParams(newSearchParams);
      } else {
        throw new Error("User doesn't have permissions to create Devie Type");
      }
      if (outhTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaTrafficClickIdentifiers(
          outhTokenHeader,
          dispatch
        );
      }
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
      setIsLoading(false);
      handleClose();
      await MetaEntitiesEndPointLogic.getMetaTrafficClickIdentifiers(
        outhTokenHeader,
        dispatch
      );
    }
  };

  useEffect(() => {
    if (outhTokenHeader) {
      SetIdentifierName(selectedRowData?.identifier);
      SetTrafficSource(selectedRowData?.traffic_source);
    }
  }, [selectedRowData, SetIdentifierName, SetTrafficSource, outhTokenHeader]);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
        >
          <Paper sx={{ padding: "16px 24px 20px 24px" }}>
            <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
              Create New Traffic Click Identifier
            </DialogTitle>
            <Typography sx={{ mb: 1 }}>Details</Typography>
            <Grid container mt={0} columnSpacing={3}>
              <Grid item xs={6}>
                <TextField
                  value={identifierName}
                  onChange={(e: any) => SetIdentifierName(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Identifier Name *" // Set your label here
                  placeholder="Enter unique identifier name" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={trafficSource}
                  onChange={(e: any) => SetTrafficSource(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Traffic Source *" // Set your label here
                  placeholder="Define traffic source" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Typography
              sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
            >
              All fields are mandatory.
            </Typography>

            <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
              <Button color="secondary" onClick={handleClose} sx={{ mr: 1 }}>
                CANCEL
              </Button>
              <Button
                variant="contained"
                color="secondary"
                disabled={!identifierName || !trafficSource}
                onClick={updateTrafficClickIdentifiers}
                data-tracker="235"
              >
                Save changes <SaveOutlinedIcon sx={{ ml: 1 }} />
              </Button>
            </Stack>
          </Paper>
        </Dialog>
      )}
    </>
  );
}

export default EditTrafficClickIdentifierModal;
